import { createSvgIcon } from '@mui/material';
import Styled from './custom-styled-icon'

export const CoinOutline = Styled(
	createSvgIcon(
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M8.00049 11.4C8.00049 12.17 8.60049 12.8 9.33049 12.8H10.8305C11.4705 12.8 11.9905 12.25 11.9905 11.58C11.9905 10.85 11.6705 10.59 11.2005 10.42L8.80049 9.58001C8.32049 9.41001 8.00049 9.15001 8.00049 8.42001C8.00049 7.75001 8.52049 7.20001 9.16049 7.20001H10.6605C11.4005 7.21001 12.0005 7.83001 12.0005 8.60001"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.0005 12.85V13.59"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M10.0005 6.40997V7.18997"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M9.99049 17.98C14.4032 17.98 17.9805 14.4028 17.9805 9.99C17.9805 5.57724 14.4032 2 9.99049 2C5.57773 2 2.00049 5.57724 2.00049 9.99C2.00049 14.4028 5.57773 17.98 9.99049 17.98Z"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M12.9805 19.88C13.8805 21.15 15.3505 21.98 17.0305 21.98C19.7605 21.98 21.9805 19.76 21.9805 17.03C21.9805 15.37 21.1605 13.9 19.9105 13"
				stroke="currentColor"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>,
		'CoinOutline'
	)
)

export default CoinOutline
